import { render, staticRenderFns } from "./KasMutasi.vue?vue&type=template&id=17fb98a4&"
import script from "./KasMutasi.vue?vue&type=script&lang=js&"
export * from "./KasMutasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports